<template>
  <div>
    <b-form-checkbox 
      v-model="isSelected" 
      class="m-0"
      @change="input" 
    />
  </div>
</template>

<script>
export default {
  name: 'ColumnSelect',
  props: ['row', 'column', 'is-selected'],
  data: () => {
    return {
      model: this.isSelected,
    };
  },
  mounted() {
    this.$bus.$on('clearCheckbox', () => {
      this.model = false;
    });
  },
  methods: {
    input() {
      this.$emit('select', this.row.id);
    },
  },
  destroyed() {
    this.$bus.$off('clearCheckbox');
  },
};
</script>
